import { Navigation } from './Navigation';

const DrawerContent = () => (
  <div className="scrollbar-sidebar min-h-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-contain">
    <Navigation />
  </div>
);

export default DrawerContent;
